<form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
    <p-toolbar>
        <p-floatLabel variant="on">
            <p-datepicker
                formControlName="startDate"
                appendTo="body"
                selectionMode="single"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="
                    moment().add(-10, 'year').format('YYYY') +
                    ':' +
                    moment().add(10, 'year').format('YYYY')
                "
            ></p-datepicker>
            <label for="float-dd">Start Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <p-datepicker
                formControlName="endDate"
                appendTo="body"
                selectionMode="single"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="
                    moment().add(-10, 'year').format('YYYY') +
                    ':' +
                    moment().add(10, 'year').format('YYYY')
                "
            ></p-datepicker>
            <label for="float-dd">End Date</label>
        </p-floatLabel>
        <div>
            <button
                type="button"
                pButton
                pRipple
                icon="pi pi-download"
                pTooltip="Download"
                class="p-button-secondary"
                (click)="this.dataTable.exportCSV()"

            ></button>
        </div>
    </p-toolbar>
</form>
<div style="height: 75vh">
    <p-table stripedRows #dataTable
        [value]="items"
        [columns]="cols"
        scrollHeight="flex"
        scrollDirection="both"
        [scrollable]="true"
        [virtualScroll]="true"
        [virtualRowHeight]="dropdownItemHeight"
        sortMode="multiple"
        dataKey="id"
        [loading]="loading"
    >
        <ng-template pTemplate="emptymessage">
            <tr class="empty-table">
                <td [attr.colspan]="numCols" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template #header let-columns>
            <tr>
                <!-- StartTime -->
                <th
                    pSortableColumn="StartTime"

                >
                    Start Date
                    <p-sortIcon
                        field="StartTime"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- EndTime -->
                <th pSortableColumn="EndTime" >
                    End Date
                    <p-sortIcon
                        field="EndTime"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
                <!-- Result -->
                <th pSortableColumn="Result" style="width: calc(100% - 253px)">
                    Result
                    <p-sortIcon
                        field="Result"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-rowData let-columns="columns">
            <tr>
                <!-- StartTime -->
                <td
                    [attr.title]="rowData.StartTime"
                    [ngStyle]="{ 'max-height': dropdownItemHeight }"

                >
                    {{ moment(rowData.StartTime).format('L') }}&nbsp;{{
                        moment(rowData.StartTime).format('LT')
                    }}
                </td>
                <!-- EndTime -->
                <td
                    [attr.title]="rowData.EndTime"
                    [ngStyle]="{ 'max-height': dropdownItemHeight }"

                >
                    <span
                        *ngIf="
                            moment(rowData.EndTime).isValid();
                            else processing
                        "
                    >
                        {{ moment(rowData.EndTime).format('L') }}&nbsp;{{
                            moment(rowData.EndTime).format('LT')
                        }}
                    </span>
                    <ng-template #processing> Processing... </ng-template>
                </td>
                <!-- Result -->
                <td
                    [attr.title]="rowData.Result"
                    [ngStyle]="{
                        'max-height': dropdownItemHeight,
                        width: 'calc(100% - 253px)'
                    }"
                    class="p-datatable-cell"
                >
                    {{ rowData.Result }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
